export default __webpack_public_path__ + "static/wave_circle_faq_1-14a06eb087f377337a59db1010f8c5a3.svg";